/**
 * Bridge from the `shift+C` hotkey to the My Orders panel.
 *
 * The panel owns the cancel-all confirm state, but the hotkey handler is
 * registered once on the window from the trading view. Held here (not in React
 * state) for the same reason as the amount prefill in `lastOrder`: the panel
 * mounts and unmounts under the handler, so the two sides are coupled through
 * a module-level listener instead of a prop.
 */
const listeners = new Set<() => void>();

/** Notify the panel. Returns false when no panel is mounted to take it. */
export function requestCancelAll(): boolean {
  if (listeners.size === 0) return false;
  for (const listener of listeners) listener();
  return true;
}

export function onCancelAllRequest(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
